import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { SectionContent } from './section-content';
import ExpanderSection from '../../../tab-section/expander-section/expander-section';

import { OrderOverviewSectionId } from '../../../fulfillment-plan/order-details-expanded-section-provider';
import { LabelHistoryHeaderContent } from './header-content';
import { ZeroState } from './zero-state';

import { messages } from './messages';
import style from './style.module.less';
import { emptyArray } from 'ui-components/default-props/empty';

export const LabelHistory = ({ sidePanelFulfillmentPlans = emptyArray }) => {
  const shippingCostTotal = useMemo(
    () => sidePanelFulfillmentPlans.reduce((total, { shippingCost }) => total + (shippingCost?.value ?? 0), 0),
    [sidePanelFulfillmentPlans],
  );
  // this only works for a single currency value, if we mix currency types in shippingCost this will need ajustment
  const shippingCostCurrencyCode = useMemo(() => sidePanelFulfillmentPlans[0]?.shippingCost?.code, [sidePanelFulfillmentPlans]);
  const sidePanelFulfillmentPlanCount = useMemo(() => sidePanelFulfillmentPlans.length, [sidePanelFulfillmentPlans.length]);
  return (
    <ExpanderSection
      ariaLabelMessageDescriptor={messages.expandableSectionAriaLabel}
      contentClassName={style['label-history-section-content']}
      headerContent={
        <LabelHistoryHeaderContent
          shippingCostCurrencyCode={shippingCostCurrencyCode}
          shippingCostTotal={shippingCostTotal}
          sidePanelFulfillmentPlanCount={sidePanelFulfillmentPlanCount}
        />
      }
      isFullHeightWhenExpanded
      sectionContent={sidePanelFulfillmentPlanCount > 0 ? <SectionContent /> : <ZeroState />}
      sectionId={OrderOverviewSectionId.LabelHistory}
    />
  );
};

LabelHistory.propTypes = {
  sidePanelFulfillmentPlans: PropTypes.array,
};
